export default {
      id: "ind-cross-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#ind-cross",
      toString: function () {
        return this.url;
      }
    }